<template>
  <div class="navbar">
    <div class="container">
      <button type="button" class="navbar-toggle" data-toggle="collapse" data-target=".navbar-responsive-collapse">
        <span class="icon-bar"></span>
        <span class="icon-bar"></span>
        <span class="icon-bar"></span>
      </button>
      <a class="navbar-brand" href="/"><img src="./../../assets/images/logo-web-frontpage.png" width="130" height="20" style="height:20px; margin-right:20px;" alt="LeadSocial"></a>
    </div><!-- /.container -->

    <div class="hidden-print" style="height:50px;"></div>
  </div>
</template>

<script>
export default {
  name: 'navbar'
}
</script>



// WEBPACK FOOTER //
// src/components/Partials/Navbar.vue